"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type ParagraphSectionData = Extract<CampaignPageSection, {
  type: "paragraph";
}>;

/** Blok teks sederhana khusus halaman promosi — judul (h2/h3) opsional + paragraf polos. */
export default function ParagraphSection(t0) {
  const $ = _c(19);
  const {
    section
  } = t0;
  const HeadingTag = section.heading_level === "h3" ? "h3" : "h2";
  const alignClass = section.align === "center" ? "text-center" : "text-left";
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `mx-auto max-w-2xl px-5 ${alignClass}`;
  let t3;
  if ($[2] !== HeadingTag || $[3] !== section.custom_style || $[4] !== section.heading || $[5] !== section.heading_level) {
    t3 = section.heading && <HeadingTag className={section.heading_level === "h3" ? "mb-3 text-xl font-bold text-warm-black" : "mb-3 text-2xl font-bold tracking-tight text-warm-black md:text-3xl"} style={sectionHeadingStyle(section.custom_style)}>{section.heading}</HeadingTag>;
    $[2] = HeadingTag;
    $[3] = section.custom_style;
    $[4] = section.heading;
    $[5] = section.heading_level;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== section.custom_style) {
    t4 = section.custom_style?.text_color ? {
      color: section.custom_style.text_color
    } : undefined;
    $[7] = section.custom_style;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== section.body || $[10] !== t4) {
    t5 = <p className="whitespace-pre-line text-[15px] leading-relaxed text-gray-700" style={t4}>{section.body}</p>;
    $[9] = section.body;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t6) {
    t7 = <section className="bg-white py-10 md:py-14" style={t1}>{t6}</section>;
    $[16] = t1;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}